<template>
    <custom-container-full :budget-data="budgetData">
        <div class="row">
            <div class="col-lg-12">
                <div class="block-content">
                    <h4 class="c-question c-question-first">Resumen de tu pedido</h4>
                    <summary-budget-line v-for="budgetLine in budgetLines" :budget-line="budgetLine" :key="budgetLine.id"
                                         @removed="removeLine" @duplicated="addLine" @edit="editLine"
                    ></summary-budget-line>
                    <div class="add-more-lines mb-2" @click="goMore">
                        <i class="fa fa-plus-circle"></i>
                    </div>
                    <div class="delete-budget-wrapper">
                        <b-button variant="outline-secondary" @click="resetBudget" class="delete-budget" v-b-tooltip.hover title="Borrar el presupuesto completo y empezar de nuevo">
                            Limpiar el presupuesto <i class="fas fa-trash-alt"></i>
                        </b-button>
                    </div>
                    <summary-totals :total-price="totalPrice" :parcial-pay-percent.sync="parcialPayPercent"
                                    @go-more="goMore" :goingCart="goingCart" @go-cart="goCart"
                                    :min-percent="minPercentPay"
                    >
                        <template v-slot:after-total>
                            <join-dates :join-min-date="joinMinDate" @dates-joined="datesJoined"></join-dates>
                        </template>
                    </summary-totals>
                    <edit-budget-line-modal v-if="edited" :budget-line="editingBudgetLine" @edited="edited"
                                            :tray-formats-data="trayFormatsData" @updated="updated"
                                            :tray-prices-base="trayPricesBase"
                    ></edit-budget-line-modal>
                </div>
            </div>
        </div>
        <template v-slot:replaceBudgetLines>
            <summary-totals desktop :total-price="totalPrice" :parcial-pay-percent.sync="parcialPayPercent"
                            @go-more="goMore" :goingCart="goingCart" @go-cart="goCart" :min-percent="minPercentPay"
            >
                <template v-slot:after-total>
                    <join-dates :join-min-date="joinMinDate" @dates-joined="datesJoined"></join-dates>
                </template>
            </summary-totals>
        </template>
    </custom-container-full>
</template>

<script>
    import CustomContainerFull from "./CustomContainerFull";
    import BtnNext from "./BtnNext";
    import SummaryBudgetLine from "./SummaryBudgetLine";
    import SummaryTotals from "./SummaryTotals";
    import EditBudgetLineModal from "./EditBudgetLineModal";
    import JoinDates from "./JoinDates";
    export default {
        name: "SummaryMain",
        components: {JoinDates, EditBudgetLineModal, SummaryTotals, SummaryBudgetLine, BtnNext, CustomContainerFull},
        props: {
            budgetData: {
                type: Object
            },
            budgetDataGeneral: {
                type: Object
            },
            trayFormatsData: {
                type: Array
            },
            trayPricesBase: {
                type: Object
            },
            minPercentPay: {
                type: Number,
                default: 50
            }
        },
        data() {
            return {
                budgetLines: [],
                parcialPayPercent: this.minPercentPay,
                editingId: null,
                goingCart: false
            }
        },
        computed: {
            disabledNext() {
                return true;
            },
            totalPrice() {
                return this.budgetLines.reduce((a, b) => a + b.total_price, 0);
            },
            editingBudgetLine() {
                return this.budgetLines.find(bl => bl.id === this.editingId) || null;
            },
            joinMinDate() {
                let weekDayDelivery = window.custom.params.week_day_delivery;
                let date = null;
                let dateAux = null;
                let different = false;
                this.budgetLines.forEach((bl, index) => {
                    if (index === 0) {
                        date = bl.block_to_date;
                        dateAux = bl.date;
                    }
                    if (bl.block_to_date > date) {
                        date = bl.block_to_date;
                    }
                    if (bl.date !== dateAux) {
                        different = true;
                    }
                });
                if (moment(date).isoWeekday() > weekDayDelivery) {
                    date = moment(date).add(1, 'week').toDate();
                }
                date = moment(date).isoWeekday(weekDayDelivery).toDate();
                if (!different) {
                    date = null;
                }
                return date;
            }
        },
        watch: {
            minPercentPay() {
                this.setUpParcialPayPercent();
            }
        },
        methods: {
            goMore() {
                window.location = this.route('custom.type-select');
            },
            removeLine(budgetLine) {
                this.budgetLines = this.budgetLines.filter(bl => bl.id !== budgetLine.id);
                if (this.budgetLines.length === 0) {
                    window.location = this.route('custom.type-select');
                }
            },
            addLine(budgetLine) {
                budgetLine.duplicated = true;
                this.budgetLines.push(budgetLine);
            },
            editLine(budgetLine) {
                this.editingId = budgetLine.id;
            },
            edited() {
                this.editingId = null;
            },
            datesJoined(date) {
                this.budgetLines.forEach(bl => {
                    bl.date = date;
                })
            },
            updated(budgetLine) {
                for (let index in this.budgetLines) {
                    if (this.budgetLines[index].id === budgetLine.id) {
                        this.budgetLines[index] = budgetLine;
                        break;
                    }
                }
            },
            goCart() {
                let vm = this;
                let formData = new FormData();
                formData.append('id', this.budgetDataGeneral.id);
                formData.append('porcentaje_pagar_ahora', this.parcialPayPercent);
                this.goingCart = true;
                axios.post(this.route('custom.summary-next'), formData).then((response) => {
                    window.location = this.route('carrito.index');
                }).catch(e => {
                    Vue.toasted.error("Error al enviar los datos al servidor", {
                        duration: 3000
                    });
                    console.error(e);
                }).finally(() => {
                    this.goingCart = false;
                });
            },
            setUpParcialPayPercent() {
                this.parcialPayPercent = this.minPercentPay;
            },
            resetBudget() {
                if (confirm('¿Seguro que quieres limpiar el presupuesto?')) {
                    axios.post(this.route('custom.reset-budget')).catch((e) => {
                        Vue.toasted.show('Ha ocurrido un error', {
                            type: "error",
                            duration: 3000
                        });
                        console.log(e);
                    }).then((response) => {
                        window.location = this.route('custom.index');
                    });
                }
            }
        },
        created() {
            this.budgetLines = this.budgetDataGeneral.lines;
        }
    }
</script>

<style scoped>
    .c-question-first {
        padding-top: 1.2em;
        font-weight: bold;
        padding-bottom: 1em;
    }

    .delete-budget {
        border-radius: 0;
        color: #0b72b8;
        border: 2px solid #0b72b8;
        font-weight: bold;
    }

    .delete-budget:hover {
        background-color: #c9c9c9;
    }

    .add-more-lines {
        cursor: pointer;
        text-align: center;
        margin: 0.5rem 0;
        padding: 0.5rem;
        border: 1px solid #cac8c9;
        border-radius: 7px;
        font-size: 1.2rem;
    }

    .delete-budget-wrapper {
        margin-top: 1.1rem;
        margin-bottom: 1.1rem;
    }

    @media (min-width: 992px) {
        .add-more-lines {
            margin: 0.5rem 1rem;
        }
    }


</style>

<style>

</style>
